/**
 *
 * HomePagePro
 *
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withSizes } from 'react-sizes';
// import { useQuery } from 'react-query';
// import _isEmpty from 'lodash/isEmpty';
// import _get from 'lodash/get';
// import _has from 'lodash/has';
import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
// import { get } from 'utils/api';
import Mixpanel from 'utils/mixpanelService';
import SectionNavigator from './components/SectionNavigator';
// import NavBar from './components/NavBar';
import Hero from './components/Hero';
import Individuals from './components/Individuals';
import TextualSection from './components/TextualSection';
import ResourcesSection from './components/ResourcesSection';
import ParallaxA from './components/ParallaxA';
import ParallaxB from './components/ParallaxB';
import AppSection from './components/AppSection';
import QuoteSection from './components/QuoteSection';
import ParallaxC from './components/ParallaxC';
import Footer from './components/Footer';

const useStyles = makeStyles({
  container: {
    paddingTop: ({ isMobile }) => (isMobile ? 0 : 54),
    overflowX: 'hidden',
  },
});

// const queryFn = async () => {
//   const page = await get('https://solutions.crediblemind.com/wp-json/wp/v2/pages/32');
//   return page.data;
// };

const HomePageWP = ({ isMobile }) => {
  const classes = useStyles({ isMobile });
  // const { data, isFetching } = useQuery(['home-page-wp'], queryFn, {
  //   retry: 3,
  // });

  // if (isFetching || !data) return null;

  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const $anchor = document.getElementById(window.location.hash.slice(1));
        if ($anchor) {
          const offsetTop =
            $anchor.getBoundingClientRect().top + window.pageYOffset;
          window.scroll({
            top: offsetTop - 54,
            behavior: 'smooth',
          });
        }
      }, 1000);
    }
    Mixpanel.track('Solutions Home Page - Viewed');
  }, []);

  const handleScroll = (id, source) => {
    const $anchor = document.getElementById(id);
    if ($anchor) {
      const offsetTop =
        $anchor.getBoundingClientRect().top + window.pageYOffset;
      window.scroll({
        top: offsetTop - 54,
        behavior: 'smooth',
      });

      Mixpanel.track('Solutions Home Page - Navigation Clicked', {
        section: id,
        source,
      });
    }
  };

  const handlePageExit = (url, source) => {
    Mixpanel.track('Solutions Home Page - Exit Page', {
      exitPage: url,
      source,
    });
  };

  return (
    <>
      <SectionNavigator onClick={handleScroll} />
      {/* <NavBar isHome onPageExit={handlePageExit} onClick={handleScroll} /> */}
      <div className={classes.container}>
        <Hero onPageExit={handlePageExit} />
        <Individuals onPageExit={handlePageExit} />
        <TextualSection />
        <ParallaxA onPageExit={handlePageExit} />
        <ResourcesSection onPageExit={handlePageExit} />
        <ParallaxB onPageExit={handlePageExit} />
        <AppSection onClick={handleScroll} />
        <QuoteSection />
        <ParallaxC onPageExit={handlePageExit} />
        <Footer />
        {/* <Typography variant="h1">HomePageWP</Typography>
        <div dangerouslySetInnerHTML={{ __html: data.content.rendered }} /> */}
      </div>
    </>
  );
};

HomePageWP.propTypes = {
  isMobile: PropTypes.bool,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 970,
});

export default withSizes(mapSizesToProps)(HomePageWP);
